<script setup>
const props = defineProps({
    value: String
})
</script>

<template>
    <i v-if="value" class="bi-check-lg"/>
</template>